import Breadcrumb from '@/components/feature/Breadcrumb';
import PageSEO from '@/components/base/PageSEO';
import { organizationSchema, getWebPageSchema, getBreadcrumbSchema } from '@/mocks/seo';

export default function About() {
  return (
    <>
      <PageSEO
        schemas={[
          organizationSchema,
          getWebPageSchema(
            '关于我们 - 春色影视',
            '春色影视是一个致力于为观众提供高品质在线观影体验的影视平台。免费、高清、流畅的影视播放服务，电影电视剧全集实时更新。',
            'https://chunseys.com/about',
          ),
          getBreadcrumbSchema([
            { name: '首页', url: 'https://chunseys.com/' },
            { name: '关于我们', url: 'https://chunseys.com/about' },
          ]),
        ]}
      />
      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        <section className="w-full px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <div className="w-16 h-16 md:w-20 md:h-20 flex items-center justify-center bg-primary-500 rounded-2xl mx-auto mb-4 md:mb-6">
                <i className="ri-movie-2-line text-3xl md:text-4xl text-background-50"></i>
              </div>
              <h1 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                关于春色影视
              </h1>
              <p className="text-sm md:text-base text-foreground-500 max-w-2xl mx-auto leading-relaxed">
                春色影视是一个致力于为观众提供高品质在线观影体验的影视平台。我们专注于免费、高清、流畅的影视播放服务。
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-14">
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100/80 mx-auto mb-3">
                  <i className="ri-eye-line text-xl text-accent-700"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950">5000万+</h3>
                <p className="text-xs text-foreground-500 mt-1">累计观影人次</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100/80 mx-auto mb-3">
                  <i className="ri-movie-line text-xl text-primary-700"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950">10万+</h3>
                <p className="text-xs text-foreground-500 mt-1">影视资源数量</p>
              </div>
              <div className="p-6 rounded-lg bg-background-50 border border-background-200/70 text-center">
                <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100/80 mx-auto mb-3">
                  <i className="ri-user-smile-line text-xl text-secondary-700"></i>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-foreground-950">99.7%</h3>
                <p className="text-xs text-foreground-500 mt-1">用户满意度</p>
              </div>
            </div>

            <div className="space-y-8 md:space-y-10">
              <div className="p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70">
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌故事
                </h2>
                <div className="text-sm text-foreground-700 leading-relaxed space-y-3">
                  <p>
                    春色影视成立于2020年，由一群热爱电影电视的年轻人创立。我们深知观众在寻找高质量影视内容时的困难——卡顿的播放体验、模糊的画质、繁琐的注册流程——这些问题都让观影变成一种折磨。
                  </p>
                  <p>
                    因此，我们立下了一个简单的目标：让每个人都能轻松、免费地享受高品质的影视内容。经过多年的技术积累和内容建设，春色影视已经发展成为国内领先的免费影视平台。
                  </p>
                  <p>
                    我们的技术团队持续优化播放引擎，确保每一位用户都能体验到"秒开无卡顿"的流畅观影。我们的内容团队日夜不停地更新最新的电影、电视剧，让精彩永不间断。
                  </p>
                </div>
              </div>

              <div className="p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70">
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  平台优势
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {[
                    { icon: 'ri-shield-flash-line', title: '极速播放', desc: '自主研发播放引擎，智能CDN加速，确保秒开不缓冲' },
                    { icon: 'ri-hd-line', title: '高清画质', desc: '全高清资源，支持多种清晰度切换，给你最好的视觉体验' },
                    { icon: 'ri-lock-unlock-line', title: '完全免费', desc: '无需注册登录，无需付费订阅，打开即看，真正免费' },
                    { icon: 'ri-smartphone-line', title: '多端适配', desc: '电脑、平板、手机全平台支持，随时随地畅享影视' },
                  ].map((item) => (
                    <div key={item.title} className="flex gap-3 p-4 rounded-lg bg-background-100">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100/80">
                        <i className={`${item.icon} text-lg text-accent-700`}></i>
                      </div>
                      <div>
                        <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                        <p className="text-xs text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div className="p-6 md:p-8 rounded-lg bg-background-50 border border-background-200/70">
                <h2 className="text-lg md:text-xl font-bold text-foreground-950 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
                  联系我们
                </h2>
                <div className="text-sm text-foreground-700 leading-relaxed space-y-3">
                  <p>
                    如果您在使用过程中遇到任何问题，或者有任何建议和意见，欢迎通过以下方式联系我们：
                  </p>
                  <div className="flex flex-col gap-3 mt-4">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100">
                        <i className="ri-mail-line text-lg text-secondary-700"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">电子邮箱</p>
                        <p className="text-sm font-medium text-foreground-800">contact@chunseys.com</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                        <i className="ri-customer-service-line text-lg text-primary-700"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">客服热线</p>
                        <p className="text-sm font-medium text-foreground-800">400-888-6666</p>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                        <i className="ri-time-line text-lg text-accent-700"></i>
                      </div>
                      <div>
                        <p className="text-xs text-foreground-500">工作时间</p>
                        <p className="text-sm font-medium text-foreground-800">周一至周日 9:00 - 21:00</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}